import { render, staticRenderFns } from "./pendingTransactionsReport.vue?vue&type=template&id=096bda1f&"
import script from "./pendingTransactionsReport.vue?vue&type=script&lang=js&"
export * from "./pendingTransactionsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports